import { render, staticRenderFns } from "./NotificationAlert.vue?vue&type=template&id=d37ccd4e&lang=pug"
import script from "./NotificationAlert.vue?vue&type=script&lang=ts"
export * from "./NotificationAlert.vue?vue&type=script&lang=ts"
import style0 from "./NotificationAlert.vue?vue&type=style&index=0&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports